import script from "./ads.vue?vue&type=script&lang=ts&setup=true"
export * from "./ads.vue?vue&type=script&lang=ts&setup=true"

import "./ads.vue?vue&type=style&index=0&id=703f1069&lang=css"

const __exports__ = script;

export default __exports__